export default {
    inquiry: 'คำขอ',
    cancel: 'ยกเลิก',
    save: 'บันทึก',
    profile: 'ข้อมูลส่วนตัว',
    employeeId: 'รหัสพนักงาน',
    employeeFullname: 'ชื่อ - นามสกุล',
    email: 'อีเมล',
    position: 'ตำแหน่ง',
    bureau: 'สำนักงาน / หน่วยงาน',
    approve: 'อนุมัติ',
    reject: 'ปฏิเสธ',
    pending: 'รอดำเนินการ',
    inquiryStatus: 'สถานะคำร้องขอ',
    description: 'คำอธิบาย',
    attachment: 'เอกสารเเนบ',
    downloadFile: 'ดาวน์โหลดไฟล์',
    date: 'วันที่',
    approvedBy: 'อนุมัติโดย',
    rejectedBy: 'ปฏิเสธโดย',
    congratulation: 'ยินดีด้วย',
    errorMessage: 'เกิดข้อผิดพลาด'
}
